import { useCallback, useMemo } from "react";
import { useAddinData } from "./useAddinData";
import { useUpdateAddIn } from "./useUpdateAddIn";
import { useGeotabClient } from "@/components/GeotabClientContext";
import AddInIds from "@/constants/AddInIds";
import { RowDetailLayoutData } from "@/models/RowDetailLayoutData";

const LAYOUT_ID = "rowDetailPanelOrder";

export function useRowDetailLayout(defaultOrder: string[]) {
  const { username } = useGeotabClient();
  const { data = [] } = useAddinData<RowDetailLayoutData>(AddInIds.rowDetailLayout);
  const mutation = useUpdateAddIn<RowDetailLayoutData>(AddInIds.rowDetailLayout, "id");

  const userLayout = useMemo(
    () => data.find(d => d.id === `${LAYOUT_ID}-${username}`),
    [data, username],
  );

  const panelOrder = useMemo(() => {
    if (!userLayout?.panelOrder) return defaultOrder;
    // Ensure all panels are present (in case new panels were added)
    const saved = userLayout.panelOrder.filter(id => defaultOrder.includes(id));
    const missing = defaultOrder.filter(id => !saved.includes(id));
    return [...saved, ...missing];
  }, [userLayout, defaultOrder]);

  const savePanelOrder = useCallback(
    (order: string[]) => {
      mutation.mutate({
        id: `${LAYOUT_ID}-${username}`,
        panelOrder: order,
      });
    },
    [mutation, username],
  );

  return { panelOrder, savePanelOrder };
}
